import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { WaitingFrontendModule } from '../waitingfrontend/waitingfrontend.module' ;

import { AuthorizationFrontendRoutingModule } from './authorizationfrontend-routing.module';

import { SharedModule } from '../shared/shared.module';
import {
    AuthorizationFrontendCallbackLoginComponent
} from './components/callback-login/authorizationfrontend-callback-login.component';
import {
    AuthorizationFrontendCallbackLogoutComponent
} from './components/callback-logout/authorizationfrontend-callback-logout.component';
import { AuthorizationFrontendProfileComponent } from './components/profile/authorizationfrontend-profile.component';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';

export { AuthorizationFrontendGuard } from './guards/authorizationfrontend-guard' ;
export { AuthorizationModuleViewGuard } from './guards/authorization-moduleview-guard' ;
export { AuthorizationFrontendService } from './services/authorizationfrontend.service' ;
export { AuthorizationFrontendProfileComponent } from './components/profile/authorizationfrontend-profile.component' ;
export { CookieInterceptor } from './interceptors/cookie.interceptor';

@NgModule({ declarations: [
        AuthorizationFrontendCallbackLoginComponent,
        AuthorizationFrontendCallbackLogoutComponent,
        AuthorizationFrontendProfileComponent
    ],
    exports: [AuthorizationFrontendProfileComponent], imports: [RouterModule,
        SharedModule,
        WaitingFrontendModule,
        AuthorizationFrontendRoutingModule,
        CdkConnectedOverlay,
        CdkOverlayOrigin], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AuthorizationFrontendModule {
}
